module.exports = __webpack_public_path__ + "static/iceland-travel-40157cdcef50f748b77aea0fda9a8701.png";